import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';

interface VideoModalProps {
  show: boolean;
  handleClose: () => void;
  videoUrl: string;
}

const VideoModal = ({ show, handleClose, videoUrl }: VideoModalProps) => {
  // Handle escape key to close modal
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [show, handleClose]);

  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4"
      onClick={(e) => {
        // Close modal when clicking on background
        if (e.target === e.currentTarget) {
          handleClose();
        }
      }}
    >
      <div className="relative w-full max-w-4xl bg-white rounded-lg overflow-hidden">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-white text-2xl bg-black/50 hover:bg-black/70 rounded-full w-10 h-10 flex items-center justify-center z-10 transition-all duration-200 hover:scale-110"
          aria-label="Close video modal"
        >
          ✕
        </button>

        {/* Video */}
        <div className="aspect-video w-full">
          <ReactPlayer
            url={videoUrl}
            playing
            controls
            width="100%"
            height="100%"
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload',
                  disablePictureInPicture: true,
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
